export enum TourneyContestScoringType {
	Cumulative,
	Consecutive,
	Kans,
	EliminationBrackets,
	Gacha,
	SmokingSexyStyle,
	Hunting
}
